// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--gprGs","title":"a10a3f92e9--title--Iq4ic","text":"a10a3f92e9--text--bFq_U"};